import { childrenOfType as original, forbidExtraProps } from 'airbnb-prop-types';
import PropTypes from 'prop-types';

function isEmotionType() {
  for (var _len = arguments.length, types = new Array(_len), _key = 0; _key < _len; _key++) {
    types[_key] = arguments[_key];
  }

  return function validator(props, propName, componentName) {
    var _propValue$props;

    var propValue = props[propName];

    if (types.includes(propValue === null || propValue === void 0 ? void 0 : (_propValue$props = propValue.props) === null || _propValue$props === void 0 ? void 0 : _propValue$props.__EMOTION_TYPE_PLEASE_DO_NOT_USE__)) {
      return null;
    }

    return new Error("Invalid prop ".concat(propName, " provided to ").concat(componentName));
  };
}

var childrenOfType = function childrenOfType() {
  return PropTypes.oneOfType([original.apply(void 0, arguments), isEmotionType.apply(void 0, arguments)]);
};

export default childrenOfType;